import React from 'react';

import { componentTypes, Snippet } from '@white-nl/instantsearch-components';
import {
  Megaphone, Newspaper, PlugCircleBolt, Star, Suitcase,
} from '../../ui/icons/classic/light';

export default function Hit({ hit, additionalData }: componentTypes.HitProps) {
  const {
    uri,
    title,
    section,
  } = hit;

  const {
    translates,
    sectionMapping,
  } = additionalData;

  const {
    search,
  } = translates;

  return (
    <a
      href={Craft.getSiteUrl(uri)}
      className="group no-underline block bg-white w-full pb-8 mb-8 last:pb-0 last:mb-0 not-last:border-b not-last:border-gray-950/10"
    >
      <div className="flex gap-3 items-center leading-none text-grey-400 text-sm pb-6">
        {section === 'case' && (
          <Star iconClass="w-4.5" />
        )}
        {section === 'page' && (
          <Newspaper iconClass="w-4.5" />
        )}
        {section === 'insight' && (
          <Megaphone iconClass="w-4.5" />
        )}
        {section === 'job' && (
          <Suitcase iconClass="w-4.5" />
        )}
        {section === 'plugin' && (
          <PlugCircleBolt iconClass="w-4.5" />
        )}
        {Craft.t(search, sectionMapping[section])}
      </div>
      <h2 className="font-bold leading-snug text-2xl pb-3 group-hover:underline">
        {title}
      </h2>
      <div className="flex flex-col items-start justify-start not-italic relative w-full">
        <div className="flex-col justify-center max-w-full overflow-ellipsis overflow-hidden relative text-near-black text-md md:text-lg leading-loose">
          <Snippet
            hit={hit}
            attribute="content"
            classNames={{
              highlighted: 'bg-yellow theme-contrast:bg-gray-950 theme-contrast:text-white',
              nonHighlighted: 'only:line-clamp-5',
            }}
          />
        </div>
        <div className="group-hover:underline font-bold text-blue-dark-1">
          {Craft.getSiteUrl(uri)}
        </div>
      </div>
    </a>
  );
}
